module.exports = __webpack_public_path__ + "static/media/ImgEmpty.054be4fa.png";